
























































import { Component, Watch } from 'vue-property-decorator'
import api from "../../api/index"
import Lists from '../components/Lists.vue'

@Component
export default class AccessPointList extends Lists {
  isLoading = true
  dataType = 'admins'
  dataTypeLabel = 'administrateur'
  accessPoints = []

  wordSearched = ""

  goToAccessPoint(row:any) {
    const accessPointId = row.id
    this.$router.push({ name: 'accessPointProfile', params: { accessPointId }})
  }

  async mounted() {
    await api.setToken()
    this.isLoading = true
    await this.getAllAccessPoints()
    this.isLoading = false
  }

  @Watch('perPage')
  @Watch('wordSearched')
  @Watch('currentPage')
  onSearchPropsChanged(val: any, old: any) {
    if ((old && val && val.toString() === old.toString()) || this.isLoading) {
      return
    }
    this.getAllAccessPoints()
  }

  async fetchData() {
    this.getAllAccessPoints()
  }

  async getAllAccessPoints() {
    try {
      const res = await api.get("bo/access_points", { params: {
        page: this.currentPage,
        per_page: this.perPage,
        keywords: this.wordSearched,
        order: this.sortField,
        order_desc: this.sortOrder,
      }})
      this.totalPages = parseInt(res.headers["x-pagination-total-pages"])
      this.totalResults = parseInt(res.headers["x-pagination-total"])
      this.perPage = parseInt(res.headers["x-pagination-per-page"])

      this.accessPoints = res.data
    } catch (e) {
      if (e.response.status !== 200) {
        console.log(e.response.status)
      }
    }
  }

}
